module.exports = __webpack_public_path__ + "media/images/shared/icon-academy-informations-white-7e3dee77b45bf2aa7d44fba9389e70b6.png";